import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const ResponsiblePartyValues = ["BUYER", "HOMEOWNER", "CONTRACTOR", "AHJ", "RELATED_PROJECT", "REMI"] as const;
/**
 * Use this if you need to zod parse it
 */
export const ResponsiblePartySchema = z.enum(ResponsiblePartyValues);
/**
 * Use this if you need to use the literal value
 */
export const ResponsibleParty = ResponsiblePartySchema.enum;
/**
 * Use this if you need to the type
 */
export type ResponsibleParty = z.infer<typeof ResponsiblePartySchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const ResponsiblePartyDisplayName: Record<ResponsibleParty, string> = {
  BUYER: "Solar company",
  HOMEOWNER: "Homeowner",
  CONTRACTOR: "Contractor",
  AHJ: "AHJ",
  RELATED_PROJECT: "Related project",
  REMI: "Remi",
} as const;
